import { render } from "./recoveryPass.vue?vue&type=template&id=9258ecf8&scoped=true"
import script from "./recoveryPass.vue?vue&type=script&lang=js"
export * from "./recoveryPass.vue?vue&type=script&lang=js"

import "./recoveryPass.vue?vue&type=style&index=0&id=9258ecf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9258ecf8"]])

export default __exports__